module.exports = __webpack_public_path__ + "img/中间图片.d0c01e94.png";